import { gql } from '@apollo/client';

export const CANDIDATE_PICTURE = gql`
  query CANDIDATE_PICTURE($uniqId: String!) {
    candidatePicture(uniqId: $uniqId) {
      url
    }
  }
`;
